export default {
  "no-pointer": "_no-pointer_dfll66"
};